var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link border-0 p-0 min-w-auto",attrs:{"type":"button","data-toggle":"modal","data-target":"#menu-modal"},on:{"click":_vm.doToggleMenuModal}},[_c('i',{staticClass:"forch-icon-menu"})])}
var staticRenderFns = []

export { render, staticRenderFns }